import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthProvider'
import { Cargando } from '../kit'

/**
 * Guardia de ruta: muestra `children` solo con sesión. Sin sesión manda al login
 * recordando a dónde iba (?next=), para volver ahí después de entrar.
 * AuthProvider ya preguntó por la sesión al montar la app; acá solo se espera.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { estado } = useAuth()
  const { pathname, search } = useLocation()

  if (estado === 'desconocido' || estado === 'verificando') return <Cargando texto="Verificando tu sesión…" />
  if (estado === 'sin-sesion') {
    return <Navigate to={`/login?${new URLSearchParams({ next: pathname + search })}`} replace />
  }
  return <>{children}</>
}
